<template>
  <div id="add-new-order-modal">
    <v-layout row justify-center>
      <v-dialog v-model="cancelOrderModal" persistent max-width="530px">
        <v-card>
          <form action="" @submit.prevent="submitForm()">
            <v-card-title>
              <v-flex xs11 sm11 md11><span class="headline">{{ $t('customer.cancelOrderTitle') }}</span></v-flex>
              <v-flex xs1 sm1 md1>
                <v-btn flat @click="closeCancelingOrderModal(), $validator.reset()" class="close"
                  ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn
                >
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert type="success" :value="cancelAlert">
                {{ $t('adminCancelOrder.orderCanceledSuccessfully') }}
              </v-alert>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md5>
                    <v-text-field
                      :label="$t('customer.cancelReasonLabel')"
                      v-model="cancelData.cancel_reason"
                      data-vv-name="Cancel reason"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeCancelingOrderModal(), $validator.reset()"
                outline
                color="normal"
                >{{ $t('common.cancel') }}</v-btn
              >
              <v-btn type="submit" style="height:auto" class="rtl-mr-4pct" outline color="success"
                >{{ $t('common.save') }}</v-btn
              >
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: [
    'cancelOrderModal',
    'closeCancelingOrderModal',
    'cancelAlert',
    'cancelData',
    'cancelingOrder'
  ],

  methods: {
    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.cancelingOrder()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/customer/customerCancelOrder.vue